var _path, _path2, _rect, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5557 13.8V12.9C15.5557 12.4226 15.3559 11.9648 15.0003 11.6272C14.6446 11.2896 14.1623 11.1 13.6594 11.1H10.3409C9.83794 11.1 9.35561 11.2896 8.99999 11.6272C8.64437 11.9648 8.44458 12.4226 8.44458 12.9V13.8",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.1C13.2273 11.1 14.2223 10.0926 14.2223 8.84998C14.2223 7.60733 13.2273 6.59998 12 6.59998C10.7728 6.59998 9.77783 7.60733 9.77783 8.84998C9.77783 10.0926 10.7728 11.1 12 11.1Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3,
    width: 16,
    height: 18,
    rx: 4,
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3335 16.5H14.4555",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountDetails);
export default __webpack_public_path__ + "static/media/account-details.91fbb51a6519d0f2915b562e1bbe46a8.svg";
export { ForwardRef as ReactComponent };